import * as React from 'react';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ListByReferenceDisplayLabel from 'flow-doctor-lib/components/timeline/labels/ListByReferenceDisplayLabel';
import EnrollmentChecksButton from 'flow-doctor-lib/components/timeline/EnrollmentChecksButton';
import { WarningIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LIST_WARNING_SOURCES = ['OBJECT_MERGE', 'MIGRATION'];
const ListMembershipTimelineItemLabel = ({
  logItem
}) => {
  const objectListMembership = logItem.type === 'LIST_MEMBERSHIP' ? logItem.data : logItem.data.objectListMembership;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ListByReferenceDisplayLabel, {
      logItem: logItem
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignSelf: "center",
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.source",
        options: {
          sourceLabel: objectListMembership.objectSegSource
        }
      }), getIsInternal() && LIST_WARNING_SOURCES.includes(objectListMembership.objectSegSource) && /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: objectListMembership.objectSegSource === 'OBJECT_MERGE' ? 'flow-doctor-lib.flows.objectLifecycle.listMembershipHistory.mergedWarning' : 'flow-doctor-lib.flows.objectLifecycle.listMembershipHistory.migrationWarning'
        }),
        children: /*#__PURE__*/_jsx(IconHolder, {
          icon: WarningIcon,
          color: "fill-caution-default"
        })
      })]
    }), /*#__PURE__*/_jsx(EnrollmentChecksButton, {
      timelineItem: logItem
    })]
  });
};
export default ListMembershipTimelineItemLabel;